import { HStack as NbHStack } from 'native-base';

import { addWithConfig } from '../../utils';

export const HStack = NbHStack;

export default addWithConfig(HStack);
